import React from 'react';
import ServiceCollection from '../ServiceCollection';
import TPEAction from 'src/models/common/TPEAction';
import { BulkPromotionState } from './BulkPromotionState';

export interface BulkPromotionContextType {
    services: ServiceCollection;
    bulkPromotionState: BulkPromotionState;
    bulkPromotionDispatch: React.Dispatch<TPEAction>;
}

export const BulkPromotionContext = React.createContext<BulkPromotionContextType>({} as BulkPromotionContextType);
